import { Delegate } from 'vendor';
class DiscountCodeForm extends HTMLElement {
	connectedCallback() {
		this.discountInput = this.querySelector('[name="discount_code"]');
		this.invalidDiscountMessage = this.querySelector('[invalid-discount-message]');
		this.delegate = new Delegate(this);
		this.onSubmitListener = this.onSubmit.bind(this);
		this.onkeydownListener = this.onkeydown.bind(this);
		this.delegate.on('keydown', '[name="discount_code"]', this.onkeydownListener);
		this.delegate.on('click', 'button', this.onSubmitListener);
		this.delegate.on('blur', '[name="discount_code"]', this.onBlur.bind(this));
	}
	disconnectedCallback() {
		this.delegate.off('keydown', '[name="discount_code"]', this.onkeydownListener);
		this.delegate.off('click', 'button', this.onSubmitListener);
	}
	validate() {
		if (this.discountInput.validity.valueMissing) {
			this.discountInput.setCustomValidity(window.themeVariables.strings.errorMessageValueMissing);
		} else {
			this.discountInput.setCustomValidity(window.themeVariables.strings.errorMessageGeneric);
		}
		this.discountInput.reportValidity();
	}
	onBlur(event) {
		this.discountInput.setCustomValidity('');
	}
	onkeydown(event) {
		if (event.key === 'Enter') {
			event.preventDefault(); // stop form submission
			const discountCode = event.target.value.trim();
			if (discountCode) {
				this.updateDiscountCode({ discountCode });
			} else {
				this.validate();
			}
		}
	}
	onSubmit(event) {
		event.preventDefault();
		const discountCode = this.discountInput.value.trim();
		if (discountCode) {
			this.updateDiscountCode({ discountCode: discountCode });
		} else {
			this.validate();
		}
	}
	async updateDiscountCode({ discountCode }) {
		document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
		let sectionsToBundle = [];
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }),
		);
		const data = {
			discount: discountCode,
			sections: sectionsToBundle.join(','),
		};
		const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		});
		document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
		if (response.ok) {
			const cartContent = await response.json();
			const discountCodes = cartContent.discount_codes;
			// true when the inserted code is valid
			if (discountCodes.length && discountCodes[0].code === discountCode && discountCodes[0].applicable) {
				document.documentElement.dispatchEvent(
					new CustomEvent('cart:change', {
						bubbles: true,
						detail: {
							cart: cartContent,
						},
					}),
				);
				this.invalidDiscountMessage.classList.add('hidden');
			} else {
				this.invalidDiscountMessage.classList.remove('hidden');
			}
		} else {
			console.error('Failed to update discount code');
		}
	}
}
if (!window.customElements.get('discount-code-form')) {
	window.customElements.define('discount-code-form', DiscountCodeForm);
}
